import { NON_EXPIRING } from "@legacy/helpers/constants/sharedStatics";

export default {
    NON_EXPIRING,
    30:'30 days',
    60:'60 days',
    90:'90 days',
    120:'120 days',
    180:'180 days',
    365:'365 days'
};
